import Vue from 'vue'

/**
 * 用户验证服务
 */
export default {
    /**
     * 获取验证码
     * @param {*} [config={}]
     */
    async getValidateCode(params, config = {}) {
        config.params = params;
        let result = await Vue.http.get('/CommonTool/GetValidateCodeImg', config)
        return result
    },

    /**
     * 发送短信验证码
     * @param {*} [config={}]
     */
    async sendMsg(params, config = {}) {
        config.params = params;
        let result = await Vue.http.get('/ShortMessage/SendMsg', config);
        return result;
    },
    /**
     * 获取token
     */
    async getToken() {
        console.log(Vue.cookies.get('tdCookie'));
        if (!Vue.cookies.get('tdCookie')) {
            let openID = Vue.local.getItem('tdOID');
            let user = JSON.parse(Vue.local.getItem('tdUser'));

            let config = {
                params: {
                    doctorID: user.DoctorID,
                    openID: openID
                }
            };

            let result = await Vue.http.get('/DoctorInfo/GetDoctorInfoByOpenID', config);

            let { Data } = result;

            if (Vue.utils.isEmpty(Data.IconPath)) {
                Data.IconPath = require("../assets/images/gril.png");
            }

            if (Vue.utils.isEmpty(Data.Birthday)) {
                Data.Age = Vue.utils.getAge(Data.Birthday);
            }

            if (Vue.utils.isEmpty(Data.MateBirthDay)) {
                Data.MateAge = Vue.utils.getAge(Data.MateBirthDay);
            }

            Vue.local.removeItem("tdToken");
            Vue.local.setItem("tdToken", Data.Password);

            Vue.local.removeItem("tdUser");
            Vue.local.setItem("tdUser", JSON.stringify(Data));

            //cookie过期时间1小時
            let exp = 60 * 60 * 1;
            //cookie键
            let cookie_key = "tdCookie";
            //cookie值，随机生成
            let cookie_value = "cookieStatus";
            Vue.cookies.remove("tdCookie");
            Vue.cookies.set(cookie_key, cookie_value, exp);
        }
    }
}


// WEBPACK FOOTER //
// ./src/_services/auth.service.js